import { RightColumnSection } from '../components/RightColumnSection'

import { useProfileOnboardingChecklist } from '../hooks/useProfileOnboardingChecklist'
import { ProfileTwoColumnsLayout } from 'containers/profile/layouts/ProfileTwoColumns'

interface OverviewLayoutProps {
  children: React.ReactNode
}

export const OverviewLayout = ({ children }: OverviewLayoutProps) => {
  useProfileOnboardingChecklist()

  return (
    <>
      <div id="profile-onboarding-checklist" className="z-20"></div>
      <ProfileTwoColumnsLayout
        leftColumnEl={children}
        rightColumnEl={<RightColumnSection />}
      />
    </>
  )
}
